// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-filter-select__control {
    height: 40px;
}

.form-control-btn{
    height: 40px;
    margin-bottom:0;
    margin-top:.1rem;
}

.react-select__control{
    max-height: 40px;
}

.ReactTable .rt-th, .ReactTable .rt-td{
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}
/* Override React-Table default styling. */
.filterable-table-container .ReactTable .rt-table {
    overflow: visible;
}

.filterable-table-container .ReactTable.-disable-actions .rt-thead .rt-resizable-header:last-child {
    overflow: visible;
}

.filterable-table-container .ReactTable .rt-table {
    display: table;
    table-layout: auto;
}

.filterable-table-container .ReactTable .rt-thead{
    display: table-header-group;
}

.filterable-table-container .ReactTable .rt-tbody {
    display: table-row-group;
    overflow: auto;
}
.filterable-table-container .ReactTable .rt-tr {
    display: table-row;
}
    /* End React-Table */
/* Add option when the last column is not an action list*/
.ReactTable.-disable-actions .rt-thead .rt-th:last-child {
    margin: inherit;
    text-align: left;
}

.messageBox {
    position: absolute !important;
    top: -40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-color: rgb(85, 85, 85) transparent transparent;
    width: 250px;
    transition: opacity 0.3s ease 0s;
    background-color: rgb(85, 85, 85);
    text-align: center;
    opacity: 0.8;
    z-index: 1;
}

.messageBox::after {
    content: "";
}

.form-check.radio-inline {
    padding-left: 0 !important;
    display: inline-block;
}

.form-check.radio-inline input[type="radio"] + .form-check-sign::after, .form-check-radio input[type="radio"] {
    margin-left: -30px;
}

.form-check.radio-inline.form-check-radio .form-check-sign::before {
    left: 25px;
}

.form-check.radio-inline.form-check-radio input[type="radio"]:checked + .form-check-sign::after {
    left: 32px;
}

.form-check.radio-inline.form-check-radio .form-check-label {
    padding-left: 1.7rem;
    margin-right: 1rem;
}

.modal-header button.close {
}

.modal-header button.close span:first-of-type {
}

.modal-dialog.modal-xl {
    top: 5%;
    padding-top: 0;
    margin-top: .5rem;
    margin-bottom: .5rem;
}

.navbar .navbar-nav .nav-item .nav-link [class^="fa"].fa-xs {
    font-size: 1.6rem;
}

.navbar .navbar-nav .nav-item .nav-link [class^="fa"].fa-xs {
    font-size: 1.6rem;
}

label.required::after {
    content: '\\00A0*';
    color: #FB404B;
}

.middle-btn {
    margin-top: 2.5rem;
}

.wrap-unset {
    white-space: unset !important;
}

.adjustments .code-col{
    width: 15%;
}

.adjustments .last-updated-col{
    width: 11.5%;
}
.adjustments .optional-code-col{
    width: 11.5%;
}
.adjustments .free-goods-col{
    width: 11.5%;
}

.adjustments .enabled-col{
    width: 11.5%;
}

.adjustments .last-updated-col .rdtPicker{
    right:0;
}

.adjustments .last-updated-col .rdtPicker::before {
    right: 12px;
    left: unset;
}

.adjustments .last-updated-col .rdtPicker::after {
    right: 12px;
    left: unset;
}

.login-height{
    min-height: calc(100vh - 173px);
}

.login-logo{
    width: 75%;
    height: 75%;
}

.label-text-logo{
    width: 75%;
    position: absolute;
    right: -35%;
    top: 80%;
    transform: translate(-50%, -50%);
}

@media (min-width: 576px){
    .label-text-logo{
        font-size: 0.4rem;
    }
}

@media (min-width: 992px){
    .label-text-logo{
        font-size: 0.6rem;
    }
}

@media (min-width: 1200px){
    .label-text-logo{
        font-size: 0.65rem;
    }
}

@media (min-width: 1400px){
    .label-text-logo{
        font-size: 0.7rem;
    }
}

.footer-notLink{
    cursor: default;
    padding: 10px 0;
    color: #9A9A9A;
}

.footer-notLink:hover{
    color: #797979
}

thead th {
    position: sticky;
    top: 0;
    background: #fff; /* or your preferred background */
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;AACvB;AACA,0CAA0C;AAC1C;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;IACI,oBAAoB;AACxB,yDAAyD;AACzD;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,qDAAqD;IACrD,YAAY;IACZ,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;AACA;;AAEA;AACA;;AAEA;IACI,OAAO;IACP,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,gBAAgB,EAAE,iCAAiC;IACnD,UAAU;AACd","sourcesContent":[".table-filter-select__control {\n    height: 40px;\n}\n\n.form-control-btn{\n    height: 40px;\n    margin-bottom:0;\n    margin-top:.1rem;\n}\n\n.react-select__control{\n    max-height: 40px;\n}\n\n.ReactTable .rt-th, .ReactTable .rt-td{\n    word-wrap: break-word;\n    word-break: break-all;\n    white-space: normal;\n}\n/* Override React-Table default styling. */\n.filterable-table-container .ReactTable .rt-table {\n    overflow: visible;\n}\n\n.filterable-table-container .ReactTable.-disable-actions .rt-thead .rt-resizable-header:last-child {\n    overflow: visible;\n}\n\n.filterable-table-container .ReactTable .rt-table {\n    display: table;\n    table-layout: auto;\n}\n\n.filterable-table-container .ReactTable .rt-thead{\n    display: table-header-group;\n}\n\n.filterable-table-container .ReactTable .rt-tbody {\n    display: table-row-group;\n    overflow: auto;\n}\n.filterable-table-container .ReactTable .rt-tr {\n    display: table-row;\n}\n    /* End React-Table */\n/* Add option when the last column is not an action list*/\n.ReactTable.-disable-actions .rt-thead .rt-th:last-child {\n    margin: inherit;\n    text-align: left;\n}\n\n.messageBox {\n    position: absolute !important;\n    top: -40%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-color: rgb(85, 85, 85) transparent transparent;\n    width: 250px;\n    transition: opacity 0.3s ease 0s;\n    background-color: rgb(85, 85, 85);\n    text-align: center;\n    opacity: 0.8;\n    z-index: 1;\n}\n\n.messageBox::after {\n    content: \"\";\n}\n\n.form-check.radio-inline {\n    padding-left: 0 !important;\n    display: inline-block;\n}\n\n.form-check.radio-inline input[type=\"radio\"] + .form-check-sign::after, .form-check-radio input[type=\"radio\"] {\n    margin-left: -30px;\n}\n\n.form-check.radio-inline.form-check-radio .form-check-sign::before {\n    left: 25px;\n}\n\n.form-check.radio-inline.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    left: 32px;\n}\n\n.form-check.radio-inline.form-check-radio .form-check-label {\n    padding-left: 1.7rem;\n    margin-right: 1rem;\n}\n\n.modal-header button.close {\n}\n\n.modal-header button.close span:first-of-type {\n}\n\n.modal-dialog.modal-xl {\n    top: 5%;\n    padding-top: 0;\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n}\n\n.navbar .navbar-nav .nav-item .nav-link [class^=\"fa\"].fa-xs {\n    font-size: 1.6rem;\n}\n\n.navbar .navbar-nav .nav-item .nav-link [class^=\"fa\"].fa-xs {\n    font-size: 1.6rem;\n}\n\nlabel.required::after {\n    content: '\\00A0*';\n    color: #FB404B;\n}\n\n.middle-btn {\n    margin-top: 2.5rem;\n}\n\n.wrap-unset {\n    white-space: unset !important;\n}\n\n.adjustments .code-col{\n    width: 15%;\n}\n\n.adjustments .last-updated-col{\n    width: 11.5%;\n}\n.adjustments .optional-code-col{\n    width: 11.5%;\n}\n.adjustments .free-goods-col{\n    width: 11.5%;\n}\n\n.adjustments .enabled-col{\n    width: 11.5%;\n}\n\n.adjustments .last-updated-col .rdtPicker{\n    right:0;\n}\n\n.adjustments .last-updated-col .rdtPicker::before {\n    right: 12px;\n    left: unset;\n}\n\n.adjustments .last-updated-col .rdtPicker::after {\n    right: 12px;\n    left: unset;\n}\n\n.login-height{\n    min-height: calc(100vh - 173px);\n}\n\n.login-logo{\n    width: 75%;\n    height: 75%;\n}\n\n.label-text-logo{\n    width: 75%;\n    position: absolute;\n    right: -35%;\n    top: 80%;\n    transform: translate(-50%, -50%);\n}\n\n@media (min-width: 576px){\n    .label-text-logo{\n        font-size: 0.4rem;\n    }\n}\n\n@media (min-width: 992px){\n    .label-text-logo{\n        font-size: 0.6rem;\n    }\n}\n\n@media (min-width: 1200px){\n    .label-text-logo{\n        font-size: 0.65rem;\n    }\n}\n\n@media (min-width: 1400px){\n    .label-text-logo{\n        font-size: 0.7rem;\n    }\n}\n\n.footer-notLink{\n    cursor: default;\n    padding: 10px 0;\n    color: #9A9A9A;\n}\n\n.footer-notLink:hover{\n    color: #797979\n}\n\nthead th {\n    position: sticky;\n    top: 0;\n    background: #fff; /* or your preferred background */\n    z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
